import { ChatType } from '@tribeplatform/gql-client/types'
import { MemberAvatarPlaceholder } from '@tribeplatform/react-components/common/components'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'
import { IconSize } from '@tribeplatform/react-ui-kit/Icon'

import { defaultGroupChatAvatar } from '../constants.js'

interface Props {
  name: string
  imageUrl?: string
  size: IconSize
  type: ChatType
}
export const ChatImage = ({ name, imageUrl, size, type }: Props) => {
  if (type === ChatType.Group && !imageUrl) {
    return (
      <Avatar
        size={size}
        name={name}
        src={defaultGroupChatAvatar.url}
        fallback={MemberAvatarPlaceholder}
      />
    )
  }
  return (
    <Avatar
      size={size}
      name={name}
      src={imageUrl}
      fallback={MemberAvatarPlaceholder}
    />
  )
}
